import React from 'react';

import { Wrapper, Content } from './ButtonGrid.styles'
import Knoppie from '../Knoppie'
import Display from '../Display'

const ButtonGrid = ({ header,children,id,destination,home }) => (

    
        <>
       
        <Wrapper> 
         <div>{header}</div>
       
        <Content>
            {children}
        </Content>
    </Wrapper>
    </>

);

export default ButtonGrid;